<script setup lang="ts">
import { computed } from 'vue';
import { DOC_TYPE_LABELS } from '@/constants';

interface Props {
  docType: keyof typeof DOC_TYPE_LABELS;
  number: number;
}

const props = defineProps<Props>();

const label = computed(() => DOC_TYPE_LABELS[props.docType]);
</script>

<template>
  <span class="citation-badge c-title-medium--xs">
    {{ label }}<span class="position">{{ number }}</span>
  </span>
</template>

<style scoped lang="scss">
.citation-badge {
  display: inline-flex;
  gap: 2px;
  padding: 0 8px;
  height: 18px;
  align-items: center;
  width: fit-content;
  border-radius: 2px;
  background-color: $color-gray200;
  color: $color-gray800;
  cursor: default;

  .position {
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    width: fit-content;
    height: 10px;
    padding: 0 4px;
    border-radius: 5px;
    background-color: $color-gray800;
    color: $color-white;
  }
}
</style>
